// extracted by css-extract-rspack-plugin
export default {"row":"Form__row--jT00C"};